const drawLogo = (ctx, x, y, s) => {
    ctx.save();
    ctx.translate(x, y);
    ctx.scale(s / 64, s / 64);
    const g = ctx.createLinearGradient(0, 0, 64, 64);
    g.addColorStop(0, "#FF6A5A");
    g.addColorStop(0.5, "#B84BF0");
    g.addColorStop(1, "#4E7CFF");
    ctx.strokeStyle = g;
    ctx.lineWidth = 9;
    ctx.lineCap = "round";
    ctx.stroke(new Path2D("M46.1 46.1 A20 20 0 1 1 37.2 12.68"));
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.moveTo(50.7, 16.3);
    ctx.lineTo(40.1, 21.2);
    ctx.lineTo(36, 5.7);
    ctx.closePath();
    ctx.fill();
    ctx.restore();
};

export async function downloadResultImage({ filename, title, big, bigSuffix, lines }) {
    await document.fonts.ready;
    const c = document.createElement("canvas");
    c.width = 1200;
    c.height = 630;
    const ctx = c.getContext("2d");

    ctx.fillStyle = "#0a0713";
    ctx.fillRect(0, 0, 1200, 630);

    const orb = (x, y, r, color) => {
        const rg = ctx.createRadialGradient(x, y, 0, x, y, r);
        rg.addColorStop(0, color);
        rg.addColorStop(1, "transparent");
        ctx.fillStyle = rg;
        ctx.fillRect(0, 0, 1200, 630);
    };
    orb(180, 60, 460, "rgba(184,75,240,0.32)");
    orb(1090, 570, 430, "rgba(255,106,90,0.22)");
    orb(980, 40, 400, "rgba(78,124,255,0.20)");

    ctx.strokeStyle = "rgba(255,255,255,0.05)";
    ctx.lineWidth = 1;
    for (let x = 0; x <= 1200; x += 72) {
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, 630);
        ctx.stroke();
    }
    for (let y = 0; y <= 630; y += 72) {
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(1200, y);
        ctx.stroke();
    }

    drawLogo(ctx, 90, 80, 74);

    const wg = ctx.createLinearGradient(190, 0, 640, 0);
    wg.addColorStop(0, "#FF6A5A");
    wg.addColorStop(0.5, "#B84BF0");
    wg.addColorStop(1, "#4E7CFF");
    ctx.fillStyle = wg;
    ctx.font = '800 62px "Baloo 2", sans-serif';
    ctx.textBaseline = "alphabetic";
    ctx.fillText("refundaja", 192, 136);

    ctx.fillStyle = "#8a8496";
    ctx.font = '700 23px "Space Mono", monospace';
    ctx.fillText(title.toUpperCase().slice(0, 60), 92, 246);

    ctx.fillStyle = "#ffffff";
    ctx.font = '800 118px "Bricolage Grotesque", sans-serif';
    ctx.fillText(big, 88, 372);
    if (bigSuffix) {
        const w = ctx.measureText(big).width;
        ctx.font = '600 38px "Hanken Grotesk", sans-serif';
        ctx.fillStyle = "#8a8496";
        ctx.fillText(bigSuffix, 100 + w, 372);
    }

    ctx.font = '400 27px "Space Mono", monospace';
    ctx.fillStyle = "#b9b3c4";
    lines.forEach((l, i) => ctx.fillText(l, 92, 438 + i * 40));

    ctx.font = '400 20px "Space Mono", monospace';
    ctx.fillStyle = "#6b6475";
    ctx.fillText(window.location.host, 92, 584);
    ctx.textAlign = "right";
    ctx.fillText(new Date().toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" }), 1108, 584);
    ctx.textAlign = "left";

    const blob = await new Promise((r) => c.toBlob(r, "image/png"));
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
}
